import { render, staticRenderFns } from "./chinese_papers.vue?vue&type=template&id=ea2cc4ba&"
import script from "./chinese_papers.vue?vue&type=script&lang=js&"
export * from "./chinese_papers.vue?vue&type=script&lang=js&"
import style0 from "./chinese_papers.vue?vue&type=style&index=0&id=ea2cc4ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports